'use client';

import { useEffect, useRef, useState } from 'react';
import { useSession } from 'next-auth/react';
import { AvatarIcon } from '@/components/icons';

import { AuthenticatedOptions } from './AuthenticatedOptions';
import { UnauthenticatedOptions } from './UnauthenticatedOptions';
import { AvatarName } from './AvatarName';
import { ProfileModal } from '../ProfileModal/ProfileModal';

export const ProfileDropdown = () => {
  const { data: session } = useSession();

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setIsOpen((prevValue) => !prevValue);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <>
      <div ref={dropdownRef} className="relative hidden lg:block" onClick={toggleDropdown}>
        {session ? <AvatarName /> : <AvatarIcon />}
        {isOpen && session && <AuthenticatedOptions />}
        {isOpen && !session && <UnauthenticatedOptions />}
      </div>
      <div className="block lg:hidden">
        <ProfileModal />
      </div>
    </>
  );
};
